<template>
  <div class="w-full h-full">
    <div class="relative w-full h-[400px]">
      <img src="../../assets/img/fuwu_1.webp" alt="service-banner" class="w-full object-cover h-full" />
      <div
        class="absolute bottom-0 left-0 right-0 text-white text-[72px] font-bold container mx-auto flex flex-col items-start justify-center">
        <div class="text-[48px] -mt-[20px] mb-10">关键词</div>
      </div>
    </div>
    <div class="container mx-auto pb-8 pt-[68px] grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6">
      <div
        v-if="loading"
        class="col-span-full text-center text-[#333333] text-[16px] py-10"
      >加载中...</div>
      <div
        v-else-if="errorMessage"
        class="col-span-full text-center text-[#333333] text-[16px] py-10"
      >{{ errorMessage }}</div>
      <a
        v-else
        v-for="(item, index) in keywords"
        :key="index"
        :href="formatLink(item.link)"
        target="_blank"
        rel="noopener noreferrer"
        class="border-[#1D3C7D] border rounded-[24px] overflow-hidden mb-6 shadow-sm px-[24px] py-[12px] flex items-center justify-center bg-[#F0F2F5] hover:bg-[#E0E4E8] transition-colors cursor-pointer"
      >
        <div class="text-[#333333] text-[16px]">
          {{ item.tItle }}
        </div>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import api from '@/api'
import { RequestError } from '@/utils/request'

type KeywordItem = {
  tItle: string // 注意：接口返回的字段名是 tItle（大写 I）
  link: string
}

const keywords = ref<KeywordItem[]>([])
const loading = ref(false)
const errorMessage = ref('')

// 格式化链接（如果链接没有协议，添加 http://）
const formatLink = (link: string): string => {
  if (!link) return '#'
  if (link.startsWith('http://') || link.startsWith('https://')) {
    return link
  }
  return `http://${link}`
}

// 加载关键词列表
const loadKeywords = async () => {
  loading.value = true
  errorMessage.value = ''
  try {
    const res = await api.keyword.getKeywordList()
    keywords.value = (res.data || []) as KeywordItem[]
  } catch (error) {
    keywords.value = []
    if (error instanceof RequestError) {
      errorMessage.value = error.message || '加载失败'
    } else {
      errorMessage.value = '加载失败'
    }
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  loadKeywords()
})
</script>

<style scoped>
:deep(.el-select) {
  width: 100%;
}

:deep(.el-input__wrapper) {
  background-color: #e8f0f5;
  border-radius: 8px;
  box-shadow: none !important;
  padding: 12px 16px;
  border: none;
}

:deep(.el-input__inner) {
  color: #333;
  font-weight: 600;
  font-size: 16px;
}

:deep(.el-input__wrapper:hover) {
  box-shadow: none !important;
}

:deep(.el-input.is-focus .el-input__wrapper) {
  box-shadow: 0 0 0 1px #409eff inset !important;
}

:deep(.el-select .el-input .el-select__caret) {
  color: #333;
  font-size: 14px;
}

:deep(.el-input.is-disabled .el-input__wrapper) {
  background-color: #f5f7fa;
  cursor: not-allowed;
}

:deep(.el-input.is-disabled .el-input__inner) {
  color: #c0c4cc;
}
</style>
